import React from "react";
export const PetCard2 = ({ text, type, mode }) => {
  const petColor = (mode) => {
    let color = "#a6a6a6";
    switch (mode) {
      case "user":
        color = "#f59090";
        break;
      case "title":
        color = "#49f56c";
        break;
      case "text":
        color = "#30bff2";
        break;
      default:
        color = "#a6a6a6";
    }
    return color;
  };
  return (
    <div
      style={{
        minWidth: 20,
        paddingRight: 2,
        paddingLeft: 2,
        height: 25,
        backgroundColor: petColor(mode ? mode : type),
        margin: 2,
        borderRadius: 3,
        textAlign: "center",
        fontSize: 13,
        color: "#FFF",
      }}
    >
      {text}
    </div>
  );
};
